import {
  Box,
  Heading,
  Text,
  Stack,
  Flex,
  Avatar,
  Center,
  Link,
  Divider,
  Icon,
  useColorModeValue, IconButton, useMediaQuery
} from '@chakra-ui/react'
import React from 'react'
import {BsChevronCompactDown, RiGithubFill, RiStackOverflowFill} from "react-icons/all";
import {scrollToY} from "../../utils/scrollToY";
import Title from "../ui/atoms/Title";

export interface HeroProps {

}

const Hero: React.FC<HeroProps> = ({}) => {
  const [isBrowser] = useMediaQuery("(min-width: 768px)")

  return (
    <Box px={64}>
      <Stack textAlign={'center'} spacing={{base: 8, md: 14}} pt={{base: 20, md: 36}} pb={{base: 12, md: 26}}>
        <Title/>
        <Heading fontWeight={500} fontSize={'3xl'} letterSpacing={4}>
          Treating coding as an art<br/>
        </Heading>
        <Center>
          <Flex justify={'space-between'} maxW={'xl'} align={'center'}>
            <Avatar size={'64px'}
                    src={'https://avatars.githubusercontent.com/u/6214415?s=64&u=4a9b3946409341508298bea359a19878e71ac8eb&v=4'}
                    alt={'Johannes Klauss'} name={'Johannes Klauss'} mr={8}/>
            <Text textAlign={'left'}>
              Hi, I am <Link color={useColorModeValue('brand.400', 'green.400')}
                             href={'https://github.com/JohannesKlauss'} isExternal>Johannes
              Klauss</Link>.
              I try to explain code <br/> and concepts with code, sketches and words.
            </Text>
          </Flex>
        </Center>
        <Center>
          <Flex justify={'space-between'} align={'center'} w={150}>
            <Link href={'https://github.com/JohannesKlauss'} isExternal alt={'Tets'}>
              <Icon as={RiGithubFill} w={9} h={9} aria-label={'Github Profile'}
                    _hover={{color: useColorModeValue('brand.400', 'green.400')}}/>
            </Link>
            <Link href={'https://stackoverflow.com/users/735226/johannes-klau%c3%9f'} isExternal>
              <Icon as={RiStackOverflowFill} w={9} h={9} aria-label={'Stackoverflow Profile'}
                    _hover={{color: useColorModeValue('brand.400', 'green.400')}}/>
            </Link>
          </Flex>
        </Center>
        <Divider borderColor={'green.400'} mt={12} borderBottomWidth={1}/>
        {!isBrowser && (
          <Center>
            <IconButton colorScheme={'gray'} icon={<BsChevronCompactDown/>} aria-label={'Scroll down'}
                        color={'green.400'}
                        opacity={0.5} onClick={() => scrollToY(window.innerHeight, 700)}/>
          </Center>
        )}
      </Stack>
    </Box>
  )
}

export default Hero
